<template>
  <div />
</template>
<script setup lang="ts">
import { useAuthentication } from '@/plugins/authenticationMSEntra'
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

onMounted(async () => {
  const router = useRouter()
  const { handleRedirect } = useAuthentication()

  await handleRedirect()

  router.push({ path: '/' })
})
</script>
